export default (state, action) => {
    switch(action.type) {
        case 'GET_STORES':
            return {
                ...state,
                stores: action.payload,
                loading: false
            };
        case 'ADD_STORE':
            return {
                ...state,
                stores: [action.payload, ...state.stores],
                loading: false
            };
        case 'DELETE_STORE':
            return {
                ...state,
                stores: state.stores.filter(store => store.store_id !== action.payload),
                loading: false
            };
        case 'UPDATE_STORE':
            return {
                ...state,
                stores: state.stores.map(store => store.store_id === action.payload.store_id ? action.payload : store),
                loading: false
            };
        case 'STORE_ERROR':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}
